module.exports = "<div :class=classNames.ruler> <div :class=classNames.ticks> <div v-for=\"tick in ticks\" :key=tick.i :class=getTickClassObject(tick) :style=getTickStyleObject() /> </div> <div :class=\"[classNames.label, classNames.labelTop]\"> 0cm </div> <div :class=\"[classNames.label, classNames.labelBottom]\"> {{ rulerSizeInCM.toFixed(2) }}cm </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/common/image-viewer/templates/image-viewer-ruler.html
// module id = 17
// module chunks = 1 2